import { toHtml } from '@fortawesome/fontawesome-svg-core';
import * as React from 'react';
import { checkout } from 'src/helper/helper';

import {injectStripe, ReactStripeElements, CardElement} from 'react-stripe-elements';

interface ICheckOutProps {
    paymentAmount: number;
    paymentType: string;
    name: string;
    email: string;
    onSuccess: () => void;
    close: () => void;
}

interface ICheckOutState {
    name: string;
    amount: number;
    errorMessage: string;
    email: string;
    loading: boolean;
}


class InjectedCheckoutForm extends React.Component<ICheckOutProps & ReactStripeElements.InjectedStripeProps, ICheckOutState > {
    constructor(props: ICheckOutProps & ReactStripeElements.InjectedStripeProps) {
        super(props);

        this.state = {
            name: '',
            amount: 0,
            errorMessage: '',
            email: '',
            loading: false
        }
        
        this.handleFieldChange = this.handleFieldChange.bind(this)
        this.handleChange = this.handleChange.bind(this)

    }

    public handleSubmit = async (event: React.ChangeEvent<HTMLFormElement>) => {
        event.preventDefault();
        try {
            if (!!this.state.email && !!this.state.name) {
                this.setState({
                    loading: true
                })

                if(!!this.props.close) {
                    this.props.close
                }

                if (!!this.props.stripe && this.props.paymentType == 'seed') {

                    // await checkout("sku", "sku_FAkhHzG6Rw5ksn");
                    await checkout("sku", "sku_MMCzfwtvfs0GAg");
                }

                if (!!this.props.stripe && this.props.paymentType == 'sprout') {

                    // await checkout("sku", "sku_FAkiF39rpSGkrd");
                    await checkout("sku", "sku_MQcK3vavk251pb");
                }

                if (!!this.props.stripe && this.props.paymentType == 'grow') {

                    // await checkout("sku", "sku_FAkjYRaxFf8mN6");
                    await checkout("sku", "sku_MQcKuGwlV2E897");
                }

                    // const {error, token}  = await this.props.stripe.createToken({name: this.state.name});
                    // const {amount, email} = this.state;

                    // if (!!token && !error) {

                    //     // fetch(`${process.env.GATSBY_API_URL}/payment`, {
                    //     //     method: 'POST',
                    //     //     headers: {
                    //     //         "Content-type": "application/json"
                    //     //     },
                    //     //     body: JSON.stringify({
                    //     //         "token": token,
                    //     //         "amount": amount,
                    //     //         "billing_email": email
                    //     //     })
                    //     // })
                    //     // .then(res => res.json())
                    //     // .then((res) => {
                    //     //     if (res.code === 200) {
                    //     //         this.setState({
                    //     //             loading: false
                    //     //         })
    
                    //     //         if (!!this.props.onSuccess){
                    //     //             this.props.onSuccess()
                    //     //         }
                    //     //     } else {
                    //     //         this.setState({
                    //     //             loading: false,
                    //     //             errorMessage: res.message.message
                    //     //         })
                    //     //     }
                    //     // }).catch((err) => {
                    //     //     this.setState({
                    //     //         loading: false,
                    //     //         errorMessage: err.message
                    //     //     })
                    //     // })

                        
                    // }
                
            } 
            else {
                this.setState({
                    errorMessage: 'Name and Email are required !'
                })
            }
        }catch(error) {
            this.setState({
                loading: false,
                errorMessage: error as string
            })
        }
    }

    public componentDidMount = () => {
        this.setState({
            amount: this.props.paymentAmount,
            name: this.props.name,
            email:this.props.email
        })
    }

    public handleFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault()
        this.setState({
            [e.target.name]: e.target.value,
            errorMessage: ''
        } as {name: string; email: string; errorMessage: string})
    }

    public handleChange = ({error}: {error?: any}) => {
        if (error) {
            this.setState({errorMessage: error.message});
        } else {
            this.setState({errorMessage: ''});
        }
    };

    public render() {
        // console.log("===========" + this.props.paymentType + this.state.email )
        return (
            <div className="container my-3">
                <form onSubmit={this.handleSubmit} className="form col-12">
                    <div className="error my-3" role="alert">
                        <p className="text-danger">{this.state.errorMessage}</p>
                    </div>
                    <div className="form-group">
                        <label>Selected Package</label> 
                        <input type="text" className="form-control" disabled={true} value={this.props.paymentType} />
                    </div>

                    <div className="form-group">
                        <label>Name</label>
                        <input className="form-control" type="text" name="name" value={this.props.name} onChange={this.handleFieldChange}/>
                    </div>
                    <div className="form-group">
                        <label>Email</label>
                        <input className="form-control" type="email" name="email" value={this.state.email} onChange={this.handleFieldChange}/>
                    </div>

                    {/* <div className="form-group">
                        <label>Card Details</label>
                        <CardElement onChange={this.handleChange}  hidePostalCode={true} style={{base: {fontSize: '18px'}}}/>
                    </div> */}


                    <div style={{ display: "flex" }}>
                    <button type="button" onClick={this.props.close} className="col-2 btn btn--stripe">close</button>
                    <button type="submit" style={{ marginLeft: "auto" }} disabled={this.state.loading} className="btn btn--stripe">{ this.state.loading ? 'loading ...' : `Pay HK${this.props.paymentAmount}`}</button>
                    </div>
                </form>
            </div>
        );
    }
}

export default injectStripe(InjectedCheckoutForm);